import React, { Component } from 'react';
import { Button } from "@progress/kendo-react-buttons";
export class CameraFeed extends Component {
    showPreview = false;
    b64 = "";

    processDevices(devices) {
        devices.forEach(device => {
            console.log(device.label);
            if (device.kind === "videoinput") this.setDevice(device);
        });
    }

    async setDevice(device) {
        const { deviceId } = device;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: false, video: { deviceId } });
        try {
            this.videoPlayer.srcObject = stream;
            this.videoPlayer.play();
        }
        catch (e) {
            console.log(e);
        }
    }

    async componentDidMount() {
        const cameras = await navigator.mediaDevices.enumerateDevices();
        this.processDevices(cameras);
    }

    takePhoto = () => {
        const context = this.canvas.getContext('2d');
        context.drawImage(this.videoPlayer, 17, 0, 266, 200);
        this.b64 = this.canvas.toDataURL();
        this.showPreview = true;
    };

    retry = () => {
        this.showPreview = false;
    }

    savePhoto = () => {
        const { sendFile } = this.props;
        this.showPreview = false;
        sendFile(this.b64);
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-4" style={{ display: this.showPreview ? "none" : "inline" }}>
                        <video ref={ref => (this.videoPlayer = ref)} width="300" height="200" />
                    </div>
                    <div className="col-md-4" style={{ width: "300px", display: this.showPreview ? "inline" : "none" }}>
                        <canvas width="300" height="200" ref={ref => (this.canvas = ref)} />
                    </div>
                </div>
                <div className="row">
                    {!this.showPreview && <div style={{ width: "300px", textAlign: "center" }}>
                        <Button onClick={this.takePhoto} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Take photo</Button>
                    </div>}
                    {this.showPreview && <div style={{ width: "300px", textAlign: "center" }}>
                        <Button onClick={this.retry} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Retry</Button>
                        &nbsp;
                        <Button onClick={this.savePhoto} themeColor={"primary"} className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base">Save Image</Button>
                    </div>}
                </div>
            </div>
        );
    }
}
